import React from 'react';
import { Table } from 'antd';
import trans from '../translations.json';
import ReducedData from '../reducedData.json';
import dict from '../dictionary';
import { dateFormater } from './utils';

class HospitalTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    var covidData = ReducedData.covidData;
    let tableData = [...covidData]
      .filter((item) => item[dict.patientHospitalizedCOVID19])
      .map((item, z) => {
        //console.log('item', item, item[`${dict.patientHospitalizedCOVID19}`])
        return {
          index: z,
          date: dateFormater(item[dict.reportedDate]),
          hospital:
            item[dict.patientHospitalizedCOVID19] &&
            item[dict.patientHospitalizedCOVID19].toLocaleString(),
          icu:
            item[dict.patientsICUwCOVID19] &&
            item[dict.patientsICUwCOVID19].toLocaleString(),
        };
      })
      .reverse();

    const columns = [
      {
        title: trans.date[this.props.lang],
        dataIndex: 'date',
        key: 'date',
        width: '33%',
      },
      {
        title: () => (
          <div
            dangerouslySetInnerHTML={{
              __html: trans.hospital.hospitalicu[this.props.lang],
            }}
          ></div>
        ),
        dataIndex: 'hospital',
        key: 'hospital',
        width: '33%',
      },
      {
        title: () => (
          <div
            dangerouslySetInnerHTML={{
              __html: trans.hospital.icu[this.props.lang],
            }}
          ></div>
        ),
        dataIndex: 'icu',
        key: 'icu',
        width: '33%',
      },
    ];
    return (
      <Table
        pagination={{ showSizeChanger: false }}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default HospitalTable;
